import { render, staticRenderFns } from "./EditRolePrivilegeForm.vue?vue&type=template&id=1e48b598&scoped=true&"
import script from "./EditRolePrivilegeForm.vue?vue&type=script&lang=js&"
export * from "./EditRolePrivilegeForm.vue?vue&type=script&lang=js&"
import style0 from "./EditRolePrivilegeForm.vue?vue&type=style&index=0&id=1e48b598&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e48b598",
  null
  
)

export default component.exports